import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { 
    FaClipboardList, 
    FaCheckCircle,
    FaClock,
    FaCreditCard
} from "react-icons/fa";
import { 
    fetchOrders 
} from "../../redux/actions/orderAction";
import { useDarkMode } from "../../App";
import "./Orders.css";

const Orders = () => {
    const { t, i18n } = useTranslation("global");
    const { isDarkMode } = useDarkMode();
    const dispatch = useDispatch();

    const { orders } = useSelector((state) => state.order);

    useEffect(() => {
        dispatch(fetchOrders(i18n.language));
    }, [dispatch, i18n.language]);

    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

    return (
        <div className={`orders-container ${isDarkMode ? "dark" : ""}`}>
            <div className="container">
                <header className="orders-header">
                    <motion.h1 
                        className="orders-title"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                    >
                        {t("orders.title") || "Order Management"}
                    </motion.h1>
                    <p className="text-muted">
                        {t("orders.subtitle") || "Manage your checkouts and view order history"}
                    </p>
                </header>

                <div className="orders-tabs">
                    <button 
                        className={`tab-btn active`}
                        disabled
                    >
                        <FaClipboardList /> {t("orders.history") || "Order History"}
                    </button>
                </div>

                <motion.div 
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    className="orders-list"
                >
                            {orders.length > 0 ? (
                                orders.map((order) => (
                                    <div key={order.order_id} className="order-card">
                                        <div className="order-header">
                                            <div className="order-id">
                                                #{order.order_id} - <span className="text-muted">{order.created_at?.split(' ')[0]}</span>
                                            </div>
                                            <div className={`order-status ${order.status === "قيد التنفيذ" ? "status-processing" : "status-completed"}`}>
                                                {order.status === "قيد التنفيذ" ? <FaClock className="me-1" /> : <FaCheckCircle className="me-1" />}
                                                {order.status}
                                            </div>
                                        </div>
                                        <div className="order-items">
                                            {order.items.map((item, idx) => (
                                                <div key={idx} className="order-item">
                                                    <img src={item.image} alt={item.product_name} className="item-img" />
                                                    <div className="item-info">
                                                        <div className="item-name">{item.product_name}</div>
                                                        <div className="item-qty-price">
                                                            {item.quantity} x {item.price} {t("orders.currency") || "EGP"}
                                                        </div>
                                                    </div>
                                                    <div className="item-total fw-bold">
                                                        {item.total} {t("orders.currency") || "EGP"}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="order-footer mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
                                            <div className="payment-method text-muted">
                                                <FaCreditCard className="me-1" /> {order.payment_method}
                                            </div>
                                            <div className="order-total h5 mb-0 fw-bold text-primary">
                                                {t("orders.total") || "Total"}: {order.total} {t("orders.currency") || "EGP"}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-5 glass-card">
                                    <FaClipboardList size={50} className="text-muted mb-3" />
                                    <h3>{t("orders.noOrders") || "No orders found"}</h3>
                                    <p>{t("orders.noOrdersDesc") || "You haven't placed any orders yet."}</p>
                                </div>
                            )}
                </motion.div>
            </div>
        </div>
    );
};

export default Orders;
